// Константы для стейблкоинов (аналогично RN версии)
export const STABLECOIN_CODES = ['USDT', 'KWDK', 'AEDK', 'SARK'] as const
export type StablecoinCode = (typeof STABLECOIN_CODES)[number]

export const CRYPTO_CODES = [
  'BTC',
  'ETH',
  'XAUT', // Gold (аналогично RN версии)
  'SOL',
  ...STABLECOIN_CODES,
] as const
export type CryptoCode = (typeof CRYPTO_CODES)[number]

export const FIAT_CODES = [
  'AED',
  'AUD',
  'BHD',
  'BRL',
  'CHF',
  'CNY',
  'DZD',
  'EGP',
  'EUR',
  'GBP',
  'GHS',
  'IDR',
  'INR',
  'KES',
  'KWD',
  'MAD',
  'MUR',
  'NGN',
  'OMR',
  'PHP',
  'QAR',
  'RUB',
  'SAR',
  'SCR',
  'SGD',
  'TND',
  'TRY',
  'TZS',
  'UGX',
  'USD',
  'ZAR',
] as const
export type FiatCode = (typeof FIAT_CODES)[number]
